(() => {
  if (customElements.get('mf-delivery-timeline')) return;
  customElements.define('mf-delivery-timeline', class extends HTMLElement {
    connectedCallback() { this.refresh(); }
    refresh() {
      const excluded = new Set((this.dataset.excludedDates || '').split(',').map(s => s.trim()).filter(Boolean));
      const count = (key, fallback) => {
        const n = Number(this.dataset[key]);
        return Number.isFinite(n) && n >= 0 ? Math.min(60, Math.round(n)) : fallback;
      };
      const processMin = count('processMin', 1), processMax = Math.max(processMin, count('processMax', 3));
      const transitMin = count('transitMin', 4), transitMax = Math.max(transitMin, count('transitMax', 8));
      const today = new Date(); today.setHours(12, 0, 0, 0);
      const addBusinessDays = (days) => {
        const date = new Date(today);
        let added = 0, guard = 0;
        while (added < days && guard < 730) {
          date.setDate(date.getDate() + 1); guard++;
          const key = `${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
          if (date.getDay() !== 0 && date.getDay() !== 6 && !excluded.has(key)) added++;
        }
        return date;
      };
      const locale = document.documentElement.lang || 'en';
      const formatter = new Intl.DateTimeFormat(locale, {month:'short', day:'numeric'});
      const range = (min, max) => {
        const start = addBusinessDays(min), end = addBusinessDays(max);
        if (start.getTime() === end.getTime()) return formatter.format(start);
        return typeof formatter.formatRange === 'function' ? formatter.formatRange(start, end) : `${formatter.format(start)} – ${formatter.format(end)}`;
      };
      const set = (selector, value) => {const node = this.querySelector(selector); if (node) node.textContent = value;};
      const arrival = range(processMin + transitMin, processMax + transitMax);
      set('[data-mf-delivery-range]', arrival);
      set('[data-mf-delivery-end]', arrival);
      set('[data-mf-delivery-dispatch]', range(processMin, processMax));
      set('[data-mf-delivery-today]', this.dataset.todayLabel);
    }
  });
})();
